import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="email-alert-form"
export default class extends Controller {
  connect() {
    this.newProjectCheckbox = document.querySelector('#email_alert_new_project')
    this.newProjectFields = document.querySelector('.new-project-fields')
    this.selectorContainer = document.querySelector('.email_alert_new_project_mode')
    this.selector = document.querySelector('#email_alert_new_project_mode')
    this.budgetInput = document.querySelector('.email_alert_new_project_min_budget')
    this.keywords = document.querySelector('.email_alert_keywords')
    this.categories = document.querySelector('.categories')

    setTimeout(() => (this.keywordsInput.maxLength = '26'), 2000)
  }

  toggleNewProjectFields() {
    this.newProjectFields.classList.toggle('hidden', !this.newProjectCheckbox.checked)
  }

  toggleProjectModeFields() {
    this.keywords.classList.toggle('hidden', this.selector.value !== 'keywords')
    this.categories.classList.toggle('hidden', this.selector.value !== 'categories')
    this.selectorContainer.classList.toggle('mb-0', this.selector.value === 'categories')
    if (this.keywordsInput) this.keywordsInput.maxLength = '26'
  }

  get keywordsInput() {
    return this.keywords.querySelector('input')
  }
}
